module.exports = {
	"articleTitle1": "About",
	"catImage": "dailylogo.png",
	"totalCats": 1,
	"name": "Student Publications Building",
	"bathroomrating": [
		{
			"rating": 3,
			"bathroom": "2nd Floor"
		}
	],
	"articleLink2": "https://www.michigandaily.com/section/news/stanford-lipsey-university-alum-and-journalist-dies-89",
	"articleSnippet1": "The student-run paper is published Monday through Friday during the fall and ... \nin the recently renovated Stanford Lipsey Student Publications Building at 420 ...",
	"articleSnippet2": "Nov 1, 2016 ... In 2005, Lipsey donated $3 million for the renovation of the Student Publications \nBuilding, which houses several campus publications including ...",
	"articleLink1": "#",
	"articleTitle2": "Stanford Lipsey, University alum and journalist, dies at 89 ",
	"address": "420 Maynard St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170320/han.CSGDebate.3.20.17.039.jpg?itok=ox4SOt38",
			"caption": "2017 Central Student Government presidential and vice-presidential candidates debate campus issues in the Student Publications Building on Monday.",
			"author": "Joshua Han"
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170323/MentalityMagazine.jpg?itok=XlyhlRI0",
			"caption": "Mentality Magazine distributes a print issue around campus once a semester.",
			"author": "Amelia Cacchione"
		}
	],
	"position": {
		"lat": 42.277061,
		"lng": -83.742289
	},
	"tips": [
		{
			"text": "Join the Michigan Daily!",
			"person": "Erik Forkin"
		}
	],
	"totalMisc": 0,
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/michigandaily.json
// module id = 919
// module chunks = 0